
















import {Component, Vue} from 'vue-property-decorator';
import {State} from 'vuex-class';
import ImageLayout from '@/components/ImageLayout.vue';

@Component({
  components: {
    ImageLayout,
  },
})
export default class ForgotPasswordSent extends Vue {
  @State('email') public email?: string;
}
